export default __webpack_public_path__ + "static/media/025-scientist.56dce4dd.svg";